import * as React from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import PropTypes from "prop-types";

// PaginationComponent
export function PaginationComponent({
  columns,
  rows = [],
  isLoading,
  paginationModel,
  paginationMeta,
  onPaginationModelChange,
  pageSizeOptions = [10, 20, 30],
  rowCount, // New prop for total row count
}) {
  const apiRef = useGridApiRef();

  return (
    <div
      style={{
        height: 500,
        width: "100%",
        fontFamily: "Poppins",
        marginTop: "-30px",
      }}
    >
      <DataGrid
        apiRef={apiRef}
        rows={rows}
        columns={columns}
        paginationMode="server"
        loading={isLoading}
        pageSizeOptions={pageSizeOptions}
        paginationModel={paginationModel}
        rowCount={rowCount}
        // disableColumnMenu
        onPaginationModelChange={(newModel) => onPaginationModelChange(newModel)}
        initialState={{ pagination: { rowCount: -1 } }}
        sx={{
          "& .MuiDataGrid-footerContainer": {
            fontFamily: "Poppins",
          },
          "& .MuiTablePagination-select": {
            fontFamily: "Poppins",
          },
          "& .MuiTablePagination-actions": {
            fontFamily: "Poppins",
          },
          "& .MuiTablePagination-displayedRows": {
            fontFamily: "Poppins",
          },
        }}
      />
    </div>
  );
}

// DataGridComponent
export function DataGridComponent({
  columns,
  rows = [],
  isLoading,
  pageSizeOptions = [10, 20, 50],
  initialPageSize = 10,
}) {
  const safeRows = rows ?? [];

  React.useEffect(() => { }, [rows, columns]);

  return (
    <div
      style={{
        height: 500,
        width: "100%",
        fontFamily: "Poppins",
        marginTop: "-30px",
      }}
    >
      <DataGrid
        rows={safeRows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: { paginationModel: { pageSize: initialPageSize } }, // Use initialPageSize
        }}
        pageSizeOptions={pageSizeOptions} // Use pageSizeOptions
        sx={{
          "& .MuiDataGrid-footerContainer": {
            fontFamily: "Poppins",
          },
          "& .MuiTablePagination-select": {
            fontFamily: "Poppins",
          },
          "& .MuiTablePagination-actions": {
            fontFamily: "Poppins",
          },
          "& .MuiTablePagination-displayedRows": {
            fontFamily: "Poppins",
          },
        }}
      />
    </div>
  );
}

// PropTypes for PaginationComponent
PaginationComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array,
  isLoading: PropTypes.bool,
  paginationModel: PropTypes.object.isRequired,
  paginationMeta: PropTypes.object.isRequired,
  onPaginationModelChange: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.array,
  rowCount: PropTypes.number.isRequired,
};

// PropTypes for DataGridComponent
DataGridComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array,
  pageSizeOptions: PropTypes.array,
  initialPageSize: PropTypes.number,
};
